import {
  CardStyleInterpolators,
  createStackNavigator,
  HeaderBackButton,
} from "@react-navigation/stack";
import { useNavigation } from "@react-navigation/native";
import * as React from "react";
import { createContext, useEffect, useRef, useState } from "react";

import ReceiptScreen from "../../screens/receipt/ReceiptScreen";

import { HeaderLeft } from "../../components/header/LeftHeader";
import { SCREENS } from "../../constants/Screens";
import { ReceiptHeader } from "../../components/header/ReceiptHeader";
import DailyReportScreen from "../../screens/dailyReport/DailyReportScreen";
import { DailyReportTabParamList } from "../../types";
import DailyReportDetailScreen from "../../screens/dailyReport/DailyReportDetailScreen";
import DailyReportHeader from "../../components/header/DailyReportHeader";

interface DailyReportHeaderContextProps {
  onReload: () => void;
  addListener: (callback: () => void) => void;
  removeListener: (callback: () => void) => void;
}

export const DailyReportHeaderContext =
  createContext<DailyReportHeaderContextProps>(
    {} as DailyReportHeaderContextProps
  );

//日報
const DailyReportTabStack = createStackNavigator<DailyReportTabParamList>();
const DailyReportTabNavigator = () => {
  const listenersRef = useRef<Set<() => void>>(new Set());

  const navigation: any = useNavigation();
  window.functions.openDrawer = () => navigation.openDrawer();

  const [confChecked, setConfChecked] = useState(false);
  window.functions.setConfChecked = setConfChecked;

  const onReload = () => {
    console.log("Reload triggered! step 02");
    // 登録されたすべてのリスナーを呼び出す
    listenersRef.current.forEach((listener) => listener());
  };

  const addListener = (callback: () => void) => {
    listenersRef.current.add(callback);
  };

  const removeListener = (callback: () => void) => {
    listenersRef.current.delete(callback);
  };

  useEffect(() => {
    const unsubscribe = navigation.addListener("tabPress", (e: any) => {
      window.reloadFlag = true;
    });
    return unsubscribe;
  }, [navigation]);

  return (
    <DailyReportHeaderContext.Provider
      value={{ onReload, addListener, removeListener }}
    >
      <DailyReportTabStack.Navigator
        screenOptions={{
          cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
        }}
      >
        <DailyReportTabStack.Screen
          name={SCREENS.DailyReport.List as keyof DailyReportTabParamList}
          component={DailyReportScreen}
          options={{
            headerTitle: "日報",
            headerLeft: HeaderLeft,
            headerRight: (props) => {
              return <DailyReportHeader {...props} />;
            },
          }}
        />
        <DailyReportTabStack.Screen
          name={SCREENS.DailyReport.Detail as keyof DailyReportTabParamList}
          component={DailyReportDetailScreen}
          options={{
            headerTitle: "日報報告",
            headerLeft: (props) => (
              <HeaderBackButton
                {...props}
                onPress={() => {
                  window.navi.navigate(SCREENS.DailyReport.List);
                }}
              />
            ),
            //   headerRight: (props) => DailyReportHeader(props),
          }}
        />
      </DailyReportTabStack.Navigator>
    </DailyReportHeaderContext.Provider>
  );
};

export default DailyReportTabNavigator;
